import { createThemeCompiler } from '../../../utils';

export const radioButtonThemeCompiler = createThemeCompiler(({ palette }) => ({
    radioButton: {
        colors: {
            checked: {
                backgroundColor: palette.white,
                borderColor: palette.themePrimary,
                checkMarkColor: palette.themePrimary
            },
            default: {
                backgroundColor: palette.white,
                borderColor: '#676E7B',
                checkMarkColor: palette.white
            },
            disabled: {
                backgroundColor: '#EDEDED',
                borderColor: '#CACED5',
                checkMarkColor: '#EDEDED'
            },
            disabledAndChecked: {
                backgroundColor: '#EDEDED',
                borderColor: '#CACED5',
                checkMarkColor: '#AAAEB5'
            },
            hovered: {
                backgroundColor: palette.white,
                borderColor: palette.themePrimary,
                checkMarkColor: ''
            }
        },
        composites: {
            groupRadioButtonGap: 25
        }
    }
}));
